import type { FaireProductEntity } from "../../entity_types/product";

export const p_20li8brobg: FaireProductEntity = {
  token: "p_20li8brobg",
  type: "product",
  name: "1st Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/070b8f08fbe371d7d4b3226eb7f6ad2ead56017eb1950643bd8a0a3b34455a84.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/90f7068198fae82d26ac6ae39efca57ed9696d9df084d59830e9309d631850e4.jpeg",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:33.576Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
